/** Placeholder shape shown while content loads. Shapes: line, block, circle. */
const Skeleton = ({ shape = 'line', width, height }) => {
  return <span className={`comp-skeleton comp-skeleton--${shape}`} style={{ width, height }} aria-hidden="true" />;
};

export default Skeleton;
